'use client'

import LoanModalShell from '@/app/components/loanComparator/modals/LoanModalShell'
import AppButtonNew from '@/app/components/atomic/molecules/AppButton'
import { PDF_EXTRACT_MAX_ATTEMPTS } from '@/app/constants/loanPdfExtract'

interface Props {
    isAnalyzing: boolean
    onConfirm: () => void
    onCancel: () => void
}

export default function LoanFillModeConfirmModal({ isAnalyzing, onConfirm, onCancel }: Props) {
    return (
        <LoanModalShell title="Repasser en saisie manuelle ?" onClose={onCancel} maxWidthClassName="max-w-[520px]">
            <p className="m-0 text-[15px] text-pale/80">
                Les champs pré-remplis à partir de votre offre seront réinitialisés. Votre date de signature est
                conservée.
            </p>

            {isAnalyzing && (
                <p className="m-0 mt-3 text-[14px] text-pale/70">
                    L&apos;analyse en cours sera abandonnée : elle comptera tout de même parmi les{' '}
                    {PDF_EXTRACT_MAX_ATTEMPTS} analyses autorisées pour ce devis.
                </p>
            )}

            <div className="mt-6 flex flex-col gap-3 md:flex-row md:justify-end">
                <AppButtonNew
                    type="button"
                    theme="outline-rounded"
                    onClick={onCancel}
                    dataTest="fill-mode-confirm-cancel"
                >
                    Annuler
                </AppButtonNew>
                <AppButtonNew
                    type="button"
                    theme="orange-rounded"
                    onClick={onConfirm}
                    dataTest="fill-mode-confirm-accept"
                >
                    Repasser en saisie manuelle
                </AppButtonNew>
            </div>
        </LoanModalShell>
    )
}
